<template>
    <b-button-group class="w-100">
        <b-button class="btn-facebook" @click="share('facebook')">
            <font-awesome-icon class="fa-fw" :icon="[ 'fab', 'facebook-square' ]" />
        </b-button>
        <b-button class="btn-twitter" @click="share('twitter')">
            <font-awesome-icon class="fa-fw" :icon="[ 'fab', 'twitter' ]" />
        </b-button>
        <b-button class="btn-line" @click="share('line')">
            <font-awesome-icon class="fa-fw" icon="comment" />
        </b-button>
    </b-button-group>
</template>

<script>
export default {
    data() {
        return {
        }
    },
    methods: {
        share(sns) {
            const urlEncoded = encodeURIComponent(location.href)
            switch (sns) {
                case 'facebook':
                    window.open('https://www.facebook.com/share.php?u=' + urlEncoded)
                    break
                case 'twitter':
                    window.open('https://twitter.com/share?url=' + urlEncoded)
                    break
                case 'line':
                    window.open('https://social-plugins.line.me/lineit/share?url=' + urlEncoded)
                    break
                default:
                    break
            }
        }
    },
}
</script>

<style lang="scss" scoped>
</style>

